<!--
  SelectedFiltersDisplay Component
  
  This component displays selected filters as removable tags with a clear all option.
  
  Props:
  - selectedFilters: Array of selected filter objects
  - showClearAll: Boolean to show/hide clear all button (default: true)
  
  Events:
  - remove-filter: Emitted when a filter is removed (filterKey, value)
  - clear-all: Emitted when clear all is clicked
  
  Filter Object Structure:
  {
    type: string,        // Filter type (e.g., 'status', 'priority')
    key: string,         // Filter key
    value: any,          // Filter value
    label: string,       // Display label
    color: string,       // Color theme
    icon: string         // Icon emoji
  }
-->
<script setup>
const props = defineProps({
  selectedFilters: {
    type: Array,
    default: () => [],
  },
  showClearAll: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['remove-filter', 'clear-all']);

const removeFilter = filter => {
  emit('remove-filter', filter);
};

const clearAll = () => {
  emit('clear-all');
};
</script>

<template>
  <div
    v-if="selectedFilters.length > 0"
    class="flex flex-wrap items-center gap-2"
  >
    <span class="text-sm font-medium text-n-slate-11">Filtros ativos:</span>
    <div
      v-for="filter in selectedFilters"
      :key="`${filter.type}-${filter.value}`"
      class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-400"
    >
      <span>{{ filter.label }}</span>
      <button
        class="ml-2 inline-flex items-center justify-center w-4 h-4 rounded-full hover:bg-blue-200 dark:hover:bg-blue-800/40 transition-colors"
        :title="`Remover filtro ${filter.label}`"
        @click="removeFilter(filter)"
      >
        <span class="text-xs font-bold">X</span>
      </button>
    </div>

    <!-- Clear All Button - Simplified condition -->
    <button
      v-if="showClearAll"
      variant="link"
      color="red"
      size="sm"
      @click="clearAll"
    >
      Limpar todos
    </button>
  </div>
</template>
